import {
	ForwardOnlyTxSender,
	RetryTxSender,
	WhileValidTxSender,
} from '@velocity-exchange/sdk';
import { ConfirmOptions } from '@solana/web3.js';
import Env from 'src/environmentVariables/EnvironmentVariables';
import { TEST_ENV } from 'src/environmentVariables/testEnvironmentVariables';

export const VELOCITY_CLIENT_OPTS: ConfirmOptions = {
	skipPreflight: true,
	commitment: Env.defaultCommitmentLevel,
	preflightCommitment: Env.defaultCommitmentLevel,
};

const FALLBACK_DEFAULT_TX_SENDER_TYPE = 'while_valid_tx_sender';

const txSenderTypeToUse = TEST_ENV.TEST_TX_FORWARDING
	? 'forward_only_tx_sender'
	: process.env.NEXT_PUBLIC_TX_SENDER_TYPE === 'while_valid_tx_sender'
		? 'while_valid_tx_sender'
		: process.env.NEXT_PUBLIC_TX_SENDER_TYPE === 'retry_tx_sender'
			? 'retry_tx_sender'
			: process.env.NEXT_PUBLIC_TX_SENDER_TYPE === 'forward_only_tx_sender'
				? 'forward_only_tx_sender'
				: FALLBACK_DEFAULT_TX_SENDER_TYPE;

export const TX_SENDER_TO_USE =
	txSenderTypeToUse === 'while_valid_tx_sender'
		? WhileValidTxSender
		: txSenderTypeToUse === 'forward_only_tx_sender'
			? ForwardOnlyTxSender
			: RetryTxSender;
